import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { INVENTORY_SELL_DOWN_BASE_PATH } from '../../../../../../../../../features/inventory/sell-down/inventory-sell-down-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'inventory-sell-down',
        label: 'Inventory',
        to: INVENTORY_SELL_DOWN_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
